// extracted by mini-css-extract-plugin
module.exports = {"Skeleton":"Skeleton_Skeleton__4WZrb","animatedCard":"Skeleton_animatedCard__1oPOO","fade":"Skeleton_fade__3pETv","animatedItem":"Skeleton_animatedItem__2Wd7i"};